// extracted by mini-css-extract-plugin
module.exports = {"addressRow":"AddressSettingsItem_addressRow__1QiAR","settings":"AddressSettingsItem_settings__30RRE"};